export default __webpack_public_path__ + "static/media/mortgages.cb874a6f.svg";